module.exports = __webpack_public_path__ + "img/forte5.237a7dd7.jpeg";